import type {
  AuthCreateCodeRequestType,
  AuthCreateCodeResponseType,
  UserSignUpMetadataType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  generateSellarMetaData,
  apiV2Request,
  ApiV2RequestScope,
} from "../apiV2Request";

export const useAuthCreateSignupCode = () => {
  return useMutation({
    // Explicit code requests must fail offline rather than queue an email.
    networkMode: "always",
    retry: false,
    mutationFn: (request: {
      data: AuthCreateCodeRequestType;
      sellarMetadata?: UserSignUpMetadataType;
    }) => {
      return apiV2Request({
        timeout: 15000,
        scope: ApiV2RequestScope.Public,
        method: "post",
        path: `auth/create-signup-code`,
        data: request.data,
        sellarMetadata: request.sellarMetadata
          ? generateSellarMetaData(request.sellarMetadata)
          : undefined,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as AuthCreateCodeResponseType,
      );
    },
  });
};
